import React, { useState, useRef, useEffect } from 'react';
import CmBadge from '../../../../GeneralComponents/ui/CmBadge';

export default function CheckboxCell({ value, checkTest }) {
  const items = Array.isArray(value) ? value : [];
  const [showAll, setShowAll] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const listRef = useRef(null);

  if (items.length === 0) return <span />;

  useEffect(() => {
    if (listRef.current) {
      setIsOverflowing(listRef.current.scrollHeight > listRef.current.clientHeight);
    }
  }, [items]);

  return (
    <div className="cm-checkbox-cell">
      <div
        ref={listRef}
        className={`cm-badge-list${!showAll ? ' cm-badge-list--clamp' : ''}`}
      >
        {checkTest && checkTest.length === 2 && (
          <i className={checkTest[0]} style={{ color: checkTest[1], marginRight: 4 }} />
        )}
        {items.map((item, i) => (
          <CmBadge key={i} color="default">{item}</CmBadge>
        ))}
      </div>
      {isOverflowing && !showAll && (
        <button
          className="cm-checkbox-cell__more"
          onClick={(e) => { e.stopPropagation(); setShowAll(true); }}
        >
          ver más...
        </button>
      )}
      {showAll && (
        <button
          className="cm-checkbox-cell__more"
          onClick={(e) => { e.stopPropagation(); setShowAll(false); }}
        >
          ver menos
        </button>
      )}
    </div>
  );
}
